import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {IWorkLog} from "../../../../../../../utils/interfaces/my_projects/IWorkLog";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";

const useApiUpdateWorkLog = (): UseMutationResult<IWorkLog, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IWorkLog> {
        try {
            const response = await put(`/api/company/${company_token}/my_projects/work_logs/${pk}`, data);
            return response.data as IWorkLog;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IWorkLog, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },

    });
};


export default useApiUpdateWorkLog;